import * as u from './utils';

export default () => {
    const fields = document.querySelectorAll('.cf7-dealer');

    if (!fields) {
        return;
    }

    const closeDropdown = () => {
        const dropdowns = document.querySelectorAll('.cf7-dealer__options.is-active');
        for (const el of dropdowns) {
            u.removeClass(el, 'is-active');
        }
    };

    const toggleDropdown = (e) => {
        e.stopPropagation();

        const field = e.currentTarget.closest('.cf7-dealer');
        u.toggleClass(field.querySelector('.cf7-dealer__options'), 'is-active');
    };

    const handleOptionClick = (e) => {
        e.stopPropagation();

        const field = e.currentTarget.closest('.cf7-dealer');
        u.removeClass(field.querySelector('.cf7-dealer__options'), 'is-active');

        const select = field.querySelector('.cf7-dealer__select');
        select.value = e.currentTarget.dataset.value;

        const selectedText = field.querySelector('.cf7-dealer__selected .text');
        selectedText.innerHTML = e.currentTarget.dataset.value;

        const selectedFlag = field.querySelector('.cf7-dealer__selected .flag');
        selectedFlag.innerHTML = e.currentTarget.querySelector('.cf7-dealer__flag').innerHTML;
    };

    for (const el of fields) {
        el.querySelector('.cf7-dealer__selected').addEventListener('click', toggleDropdown);

        for (const option of el.querySelectorAll('.cf7-dealer__option')) {
            option.addEventListener('click', handleOptionClick);
        }
    }

    document.body.addEventListener('click', closeDropdown);
};
